/* source-card.tsx generated by @compiled/babel-plugin v0.38.1 */
import "./source-card.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import React from 'react';
import { cx } from '@atlaskit/css';
import Link from '@atlaskit/link';
import { fg } from '@atlaskit/platform-feature-flags';
import { Box, Inline } from '@atlaskit/primitives/compiled';
import { ActionName, CustomUnresolvedAction, ElementName, FooterBlock, MetadataBlock, SmartLinkSize, SnippetBlock, TitleBlock } from '@atlaskit/smart-card';
import { logger } from '../../../common/utils/logger';
import { extractUrlHostname } from '../../../utils';
import { AppIcon } from '../app-icon/app-icon';
import { ErrorBoundary } from '../error-boundary';
var Card = /*#__PURE__*/React.lazy(function () {
  return import( /* webpackChunkName: "@atlaskit-internal_.smart-card" */'@atlaskit/smart-card').then(function (_ref) {
    var Card = _ref.Card;
    return {
      default: Card
    };
  });
});
var resolveUrlPlaceholder = function resolveUrlPlaceholder(url) {
  var textFragmentRegex = new RegExp('#:~:text=.*$', 'g');
  var urlWithoutTextFragment = url === null || url === void 0 ? void 0 : url.replace(textFragmentRegex, '');
  var maxLength = 30;
  var truncatedUrl = urlWithoutTextFragment.length > maxLength ? urlWithoutTextFragment.slice(0, maxLength) + '...' : urlWithoutTextFragment;
  return truncatedUrl;
};
var constructSourceUrl = function constructSourceUrl(_ref2) {
  var source = _ref2.source,
    searchSessionId = _ref2.searchSessionId;
  if (source.product === 'Confluence') {
    var url = new URL(source.url);
    url.searchParams.append('search_id', searchSessionId);
    return url.toString();
  } else {
    return source.url;
  }
};
var fallbackComponent = function fallbackComponent(_ref3) {
  var index = _ref3.index,
    source = _ref3.source,
    searchSessionId = _ref3.searchSessionId,
    onClickHandler = _ref3.onClickHandler;
  return function () {
    var _source$title, _source$title2;
    return fg('dst-a11y__replace-anchor-with-link__knowledge-disc') ? /*#__PURE__*/React.createElement(Link, {
      href: constructSourceUrl({
        source: source,
        searchSessionId: searchSessionId
      }),
      onClick: function onClick(e) {
        return onClickHandler(index, source, extractUrlHostname(source.url));
      },
      rel: "noopener noreferrer",
      target: "_blank"
    }, (_source$title = source.title) !== null && _source$title !== void 0 ? _source$title : source.url) :
    /*#__PURE__*/
    // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
    React.createElement("a", {
      href: constructSourceUrl({
        source: source,
        searchSessionId: searchSessionId
      }),
      onClick: function onClick(e) {
        return onClickHandler(index, source, extractUrlHostname(source.url));
      },
      rel: "noopener noreferrer",
      target: "_blank"
    }, (_source$title2 = source.title) !== null && _source$title2 !== void 0 ? _source$title2 : source.url);
  };
};
export var SourceCard = function SourceCard(_ref4) {
  var index = _ref4.index,
    source = _ref4.source,
    searchSessionId = _ref4.searchSessionId,
    onClickHandler = _ref4.onClickHandler,
    enableSmartLinkSources = _ref4.enableSmartLinkSources;
  var SmartLinkSource = /*#__PURE__*/React.createElement(Card, {
    appearance: "inline",
    url: source.url,
    removeTextHighlightingFromTitle: true,
    showHoverPreview: true,
    fallbackComponent: fallbackComponent({
      index: index,
      source: source,
      searchSessionId: searchSessionId,
      onClickHandler: onClickHandler
    }),
    onClick: function onClick(e) {
      onClickHandler(index, source, extractUrlHostname(source.url));
      e.preventDefault();
      window.open(constructSourceUrl({
        source: source,
        searchSessionId: searchSessionId
      }), '_blank', 'noopener, noreferrer');
    },
    onError: function onError() {
      // Nothing for now
    },
    resolvingPlaceholder: resolveUrlPlaceholder(source.url),
    placeholder: resolveUrlPlaceholder(source.url)
  });
  return /*#__PURE__*/React.createElement(ErrorBoundary, {
    fallback: /*#__PURE__*/React.createElement(React.Fragment, null)
  }, enableSmartLinkSources ? SmartLinkSource : fallbackComponent({
    index: index,
    source: source,
    searchSessionId: searchSessionId,
    onClickHandler: onClickHandler
  })());
};
var styles = {
  root: "_2rkopb1k _1h6d1l7x _1dqonqa1 _189ee4h9 _ltoz1xki _1e0c1txw _4t3ic4ae _1bah1fhb _n3tdpxbi _19bvpxbi _u5f3pxbi _ca0qpxbi",
  unresolvedActionContainerOuter: "_1e0c1txw _1bahh9n0 _19pk1wug",
  unresolvedActionContainerInner: "_2rko12b0 _11c82smr _1h6d1l7x _1dqonqa1 _189ee4h9 _4cvr1h6o _bfhksm61 _syazazsu _1e0c116y _k48p1wq8 _1bah1h6o _1tke1tcg _n3tdze3t _19bvutpp _u5f3utpp _ca0qze3t _y3gn1h6o",
  footerContainer: "_19pk1wug"
};
var unboundStyles = {
  root: "_j2xy1txw _981a1fhb"
};
function sourceFlexibleSmartCardFallbackComponent(_ref5) {
  var index = _ref5.index,
    source = _ref5.source,
    searchSessionId = _ref5.searchSessionId,
    onClickHandler = _ref5.onClickHandler;
  return function () {
    var _source$title3;
    return /*#__PURE__*/React.createElement(Link, {
      href: constructSourceUrl({
        source: source,
        searchSessionId: searchSessionId
      }),
      onClick: function onClick(e) {
        return onClickHandler(index, source, extractUrlHostname(source.url));
      },
      rel: "noopener noreferrer",
      target: "_blank"
    }, (_source$title3 = source.title) !== null && _source$title3 !== void 0 ? _source$title3 : source.url);
  };
}
function CustomUnresolvedActionContainer(_ref6) {
  var children = _ref6.children;
  return /*#__PURE__*/React.createElement(Box, {
    xcss: styles.unresolvedActionContainerOuter
  }, /*#__PURE__*/React.createElement(Box, {
    xcss: styles.unresolvedActionContainerInner
  }, children));
}
export function SourceFlexibleSmartCard(_ref7) {
  var index = _ref7.index,
    source = _ref7.source,
    searchSessionId = _ref7.searchSessionId,
    onClickHandler = _ref7.onClickHandler;
  return /*#__PURE__*/React.createElement(ErrorBoundary, {
    fallback: /*#__PURE__*/React.createElement(React.Fragment, null)
  }, /*#__PURE__*/React.createElement(Box, {
    xcss: cx(styles.root, unboundStyles.root)
  }, /*#__PURE__*/React.createElement(Card, {
    appearance: "block",
    ui: {
      clickableContainer: true,
      hideBackground: true,
      hideElevation: true,
      hidePadding: true,
      removeBlockRestriction: true
    },
    url: source.url,
    fallbackComponent: sourceFlexibleSmartCardFallbackComponent({
      index: index,
      source: source,
      searchSessionId: searchSessionId,
      onClickHandler: onClickHandler
    }),
    onClick: function onClick(e) {
      onClickHandler(index, source, extractUrlHostname(source.url));
      e.preventDefault();
      window.open(constructSourceUrl({
        source: source,
        searchSessionId: searchSessionId
      }), '_blank', 'noopener, noreferrer');
    },
    onError: function onError() {
      logger.error({
        error: new Error('Error rendering source card'),
        functionName: 'SourceFlexibleSmartCard'
      });
    },
    resolvingPlaceholder: resolveUrlPlaceholder(source.url),
    placeholder: resolveUrlPlaceholder(source.url)
  }, /*#__PURE__*/React.createElement(Inline, {
    alignBlock: "center",
    space: "space.100"
  }, /*#__PURE__*/React.createElement(AppIcon, {
    app: source.product,
    size: "small"
  }), /*#__PURE__*/React.createElement(TitleBlock, {
    hideIcon: true,
    hideRetry: true
  })), /*#__PURE__*/React.createElement(MetadataBlock, {
    maxLines: 1,
    primary: [{
      name: ElementName.AuthorGroup
    }, {
      name: ElementName.ModifiedOn
    }, {
      name: ElementName.SentOn
    }]
  }), /*#__PURE__*/React.createElement(SnippetBlock, {
    maxLines: 2
  }), /*#__PURE__*/React.createElement(Box, {
    xcss: styles.footerContainer
  }, /*#__PURE__*/React.createElement(FooterBlock, {
    actions: [{
      name: ActionName.PreviewAction,
      hideIcon: true,
      size: SmartLinkSize.Small
    }, {
      name: ActionName.CopyLinkAction,
      hideIcon: true,
      size: SmartLinkSize.Small
    }],
    hideProvider: true
  })), /*#__PURE__*/React.createElement(CustomUnresolvedAction, {
    Container: CustomUnresolvedActionContainer
  }))));
}